import React, { createContext, useContext, useState, useEffect } from 'react';
import { callAPI, LoacalVariables, Method, setLocalValues } from '../commonFunctions/CommonFunctions';

interface User {
  _id: string;
  fname: string;
  lname: string;
  userType: string;
}

export interface AuthContextType {
  loading :boolean;
  user: User | null;
  isAuthenticated: boolean;
  setUser: (user: User | null) => void;
  setIsAuthenticated: (auth: boolean) => void;
  checkAuth: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading,setLoading] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean>(false);

  const checkAuth = async () => {
    setLoading(true);
    try {
      const res = await callAPI("auth/verify", Method.GET);

      if (res?.success) {
        const userData = res.user;
        setUser(userData);
        setIsAuthenticated(true);

        setLocalValues(LoacalVariables.UserId, userData._id);
        setLocalValues(LoacalVariables.UserType, userData.userType);
        setLocalValues(LoacalVariables.Name, `${userData.fname} ${userData.lname}`);
      } else {
        setIsAuthenticated(false);
        setUser(null);
      }
    } catch (err) {
      setIsAuthenticated(false);
      setUser(null);
    }finally{
      setLoading(false);
    }
  };

  useEffect(() => {
    checkAuth();
  }, []);

  return (
    <AuthContext.Provider
      value={{
        loading,
        user,
        isAuthenticated,
        setUser,
        setIsAuthenticated,
        checkAuth,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within an AuthProvider');
  return context;
};
